import { API_URL } from "../config/connect";

// General function for handling ad status changes
const updateAdStatusById = async (adId, status, msg = null) => {
    try {
        const googleIdToken = localStorage.getItem("google_id_token");

        // Create a new FormData object
        const formData = new FormData();
        formData.append("status", status);

        // Add reject_message if rejecting the ad
        if (status === "rejected" && msg) {
            formData.append("reject_message", msg);
        }

        const response = await fetch(`${API_URL}/api/v1/admin/announcement/${adId}`, {
            method: "PATCH",
            headers: {
                Authorization: `Bearer ${googleIdToken}`,
            },
            body: formData,
        });

        if (!response.ok) {
            // HTTP/2-де statusText бос — кодты және бэкенд detail-ін көрсетеміз.
            let detail = "";
            try {
                const body = await response.json();
                detail = typeof body?.detail === "string" ? body.detail : JSON.stringify(body?.detail ?? body);
            } catch (_) {
                /* JSON емес жауап */
            }
            throw new Error(`Failed to update ad status (${response.status})${detail ? `: ${detail}` : ""}`);
        }

        const data = await response.json();
        console.log(`Ad ${status} successfully:`, data);

        // Return any reject_message if available
        if (status === "rejected" && data.reject_message) {
            return data.reject_message;
        }

        return data;
    } catch (error) {
        console.error(`Error updating ad status:`, error);
        throw error;
    }
};

// Function to reject ad (қатені шақырушыға лақтырады — сәтсіз болса
// «Отклонено» деп белгіленбесін)
const rejectAdById = (adId, reason) => {
    return updateAdStatusById(adId, "rejected", reason);
};

// Function to accept ad
const acceptAdById = (adId) => {
    return updateAdStatusById(adId, "active");
};

export { rejectAdById, acceptAdById };